import { base_url } from "Backend/api";
import { resolveStoreOrdersCount } from "./storeOrdersCount";

/**
 * يدمج استجابة تفاصيل المطعم/الماركت داخل `item.store` مثل كروت الرئيسية،
 * لأن `/api/favorites` غالباً يعيد كائناً مختصراً بلا عدد الطلبات.
 */
export async function enrichFavoriteStoresWithDetails(favorites, token) {
  const list = Array.isArray(favorites) ? favorites : [];
  const headers = {
    Accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  return Promise.all(
    list.map(async (item) => {
      const store = item?.store;
      const slug = store?.slug;
      const type = item?.store_type;
      if (!slug || (type !== "restaurant" && type !== "market")) {
        return item;
      }

      const path =
        type === "restaurant" ? "restaurants" : "markets";

      try {
        const res = await fetch(
          `${base_url}/api/${path}/${encodeURIComponent(slug)}`,
          { headers },
        );
        const json = await res.json().catch(() => ({}));
        const detail = json?.data;
        if (!detail || typeof detail !== "object") {
          return item;
        }

        const merged = { ...store, ...detail };
        const count = resolveStoreOrdersCount(merged);
        return {
          ...item,
          store: {
            ...merged,
            _orders_count_normalized: count,
          },
        };
      } catch {
        return item;
      }
    }),
  );
}
